/**
 * index.js
 *
 * @Author: apple
 * @Date: 2018/3/1 01:02
 */

import TimePicker from './TimePicker';
import TimeOptions from './TimePanel';

export default TimePicker;

export { TimePicker, TimeOptions };



// WEBPACK FOOTER //
// ./src/timePicker/index.js